import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const colorToClassNameMap = {
  primary: 'cuiButton--primary',
  secondary: 'cuiButton--secondary',
  highlight: 'cuiButton--highlight',
};

export const COLORS = Object.keys(colorToClassNameMap);

export const CuiButton = ({
  onClick,
  disabled,
  className,
  iconClassName,
  isFullWidth,
  children,
  color,
  href,
  type,
  ...rest
}) => {
  const classes = classNames(
    'cuiButton',
    className,
    colorToClassNameMap[color],
    {
      'cuiButton-isDisabled': disabled,
      'cuiButton--fullWidth': isFullWidth,
    }
  );

  let icon;

  if (iconClassName) {
    const iconClasses = classNames('cuiButton__icon', iconClassName);
    icon = <span className={iconClasses} />;
  }

  let text;

  if (children) {
    text = <span className="cuiButton__text">{children}</span>;
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {icon}
        {text}
      </a>
    );
  }

  return (
    <button
      onClick={onClick}
      className={classes}
      disabled={disabled}
      type={type}
      {...rest}
    >
      {icon}
      {text}
    </button>
  );
};

CuiButton.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  iconClassName: PropTypes.string,
  isFullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

CuiButton.defaultProps = {
  children: undefined,
  className: undefined,
  color: 'secondary',
  disabled: false,
  href: undefined,
  iconClassName: undefined,
  isFullWidth: false,
  onClick: undefined,
  type: 'button',
};



// WEBPACK FOOTER //
// ./ui/components/button/Button.js